.integration-form-success {
    background-color: var(--white);
    padding: 64px 64px;
    max-width: 512px;
    max-height: 512px;
    margin-top: 256px;
}
